module.exports = __webpack_public_path__ + "img/primary-light.056be2e5.svg";